import { useEffect, useState } from "react";
import { api } from "./api";

const KEY = "lif_dialer_prefs";
const read = () => { try { return JSON.parse(localStorage.getItem(KEY) || "{}"); } catch { return {}; } };

// Dark mode + large text for the dialers: saved on the rep's account and cached in this browser.
export function useDialerPrefs(server) {
  const [prefs, setPrefs] = useState(read);
  useEffect(() => { if (server) { setPrefs(server); localStorage.setItem(KEY, JSON.stringify(server)); } }, [server?.dark, server?.large]); // eslint-disable-line react-hooks/exhaustive-deps
  useEffect(() => {
    const on = (e) => e.key === KEY && setPrefs(read());
    window.addEventListener("storage", on);
    return () => window.removeEventListener("storage", on);
  }, []);
  const set = (k, v) => {
    const next = { ...prefs, [k]: v };
    setPrefs(next);
    localStorage.setItem(KEY, JSON.stringify(next));
    api.post("/sales/me/prefs", { [k]: v }).catch(() => {});
  };
  const cls = `${prefs.dark ? "dialer-dark" : ""} ${prefs.large ? "dialer-large" : ""}`;
  return { prefs, set, cls };
}
